/**
 * Shared constants for rate limiting
 * Used by both backend and frontend to ensure consistency
 */

export const LIMITS = {
  /** Base daily limit for invoice generation */
  DAILY_LIMIT: 50,

  /** Bonus invoices granted after watching an ad */
  AD_BONUS_AMOUNT: 50,

  /** Minimum bonus that can be added */
  MIN_BONUS: 1,

  /** Maximum bonus that can be added in a single request */
  MAX_BONUS: 50,
} as const;
